// Catálogo de ejemplos (una familia por archivo).
import { basics } from './basics.js';
import { EXAMPLES as lcd } from './lcd.js';
import { EXAMPLES as servo } from './servo.js';
import { EXAMPLES as displays } from './displays.js';
import { EXAMPLES as sensors } from './sensors.js';
import { EXAMPLES as inputs } from './inputs.js';
import { EXAMPLES as actuators } from './actuators.js';
import { EXAMPLES as motors } from './motors.js';
import { EXAMPLES as power } from './power.js';
import { EXAMPLES as tools } from './tools.js';
import { EXAMPLES as comms } from './comms.js';
import { EXAMPLES as projects } from './projects.js';
import { EXAMPLES as tft } from './tft.js';
import { EXAMPLES as extras } from './extras.js';
import { EXAMPLES as minis } from './minis.js';
import { EXAMPLES as pico } from './pico.js';

export const EXAMPLES = [...basics, ...lcd, ...servo, ...displays, ...sensors, ...inputs, ...actuators, ...motors, ...power, ...tools, ...comms, ...tft, ...extras, ...minis, ...pico, ...projects];
export const DEFAULT_EXAMPLE = 'blink-led';
